// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u057x3{margin-left:var(--ds-space-050,2px)}\n._19pk57x3{margin-top:var(--ds-space-050,2px)}\n._2hwx57x3{margin-right:var(--ds-space-050,2px)}\n._4t3i1osq{height:100%}\n._otyr57x3{margin-bottom:var(--ds-space-050,2px)}", ""]);
// Exports
module.exports = exports;
